<template>
  <div>
    <b-modal
        id="add-new-item"
        no-close-on-esc
        no-close-on-backdrop
        hide-header
        hide-footer
        centered
        :size="this.sizeModal"
        v-model="showModal"
    >
        <div class="d-flex flex-column my-2">
            <h2>Dados da Vacinação</h2>
            <span v-if="colaborador && colaborador.length > 1" class="pb-1 text-danger">{{colaborador.length}} pessoas selecionadas</span>
            <b-alert class="p-1" variant="danger" :show="item.errorApi.error != '' ">
                {{item.errorApi.error}}
            </b-alert>
            <validation-observer ref="itemRules">
                <b-form>
                    <b-row>
                        <b-col lg="6" md="12" sm="12">
                           <b-form-group 
                            label="Vacina*"
                            label-for="vacina-input">
                                <validation-provider
                                #default="{ errors }"
                                name="vacina"
                                rules="required"
                                >
                                    <v-select 
                                    id="vacina-input"
                                    v-model="item.vacina"
                                    :options="vacinasDisponiveis"
                                    label="nome_tecnico_vacina"
                                    placeholder="Selecione a vacina"
                                    :clearable="true"
                                    :disabled="vacinasDisponiveis.length <= 1"
                                    >
                                    <span slot="no-options">Nenhuma vacina disponível.</span>
                                    </v-select>
                                    <small v-if="errors[0]" class="text-danger">
                                        Este campo é de preenchimento obrigatório.
                                    </small>
                                </validation-provider>
                            </b-form-group>
                       </b-col>
                        <b-col lg="6" md="12" sm="12">
                           <b-form-group 
                            label="Lote*"
                            label-for="lote-input">
                                <validation-provider
                                #default="{ errors }"
                                name="lote"
                                rules="required"
                                >
                                    <v-select 
                                    id="lote-input"
                                    v-model="item.lote"
                                    :options="lotesFiltrados"
                                    label="numero_lote"
                                    placeholder="Lote da Vacinação"
                                    :clearable="true"
                                    :disabled="!item.vacina"
                                    >
                                    <span slot="no-options">Nenhuma opção selecionável.</span>
                                    </v-select>
                                    <small v-if="errors[0]" class="text-danger">
                                        Este campo é de preenchimento obrigatório.
                                    </small>
                                </validation-provider>
                            </b-form-group>
                       </b-col>   
                       <b-col lg="6" md="12" sm="12">
                            <b-form-group 
                            label="Vacinador*"
                            label-for="vacinador-input">
                            <validation-provider
                                #default="{ errors }"
                                name="vacinador"
                                rules="required"
                                >
                                    <v-select 
                                    id="vacinador-input"
                                    v-model="item.vacinador"
                                    :options="vacinadorSelect"
                                    label="nome"
                                    placeholder="Aplicador da vacina"
                                    :clearable="true"
                                    >
                                    <span slot="no-options">Nenhuma opção selecionável.</span>
                                    </v-select>
                                <small v-if="errors[0]" class="text-danger">
                                        Este campo é de preenchimento obrigatório.
                                    </small>
                            </validation-provider>
                            </b-form-group>
                       </b-col>
                        <b-col lg="6" md="12" sm="12">
                            <b-form-group 
                                label="Data da Aplicação*"
                                label-for="aplicacao-input"
                            >
                            <validation-provider
                                #default="{ errors }"
                                name="data_aplicacao"
                                rules="required"
                                >
                                <b-input-group>
                                    <b-form-input
                                        class="form-control"
                                        :state="errorOnDate ? false:null"
                                        id="nascimento-input"
                                        v-mask="'##/##/####'"
                                        v-model="input.data_aplicacao"
                                        placeholder="00/00/0000"
                                        autocomplete="off"
                                        @input="setInput"
                                    />
                                    <b-input-group-append>
                                        <b-form-datepicker
                                            class="form-control d-flex align-items-center"
                                            locale="pt-BR"
                                            :max="new Date()"
                                            v-model="item.data_aplicacao"
                                            button-only
                                            right
                                            :hide-header="true"
                                            label-help="Selecione a data da aplicaçãos"
                                            button-variant="custom-blue"
                                            clearable
                                            @input="setPicker"
                                        />
                                    </b-input-group-append>
                                </b-input-group>
                                    <small v-if="errors[0]" class="text-danger">
                                        Este campo é de preenchimento obrigatório.
                                    </small>
                                    <small v-if="errorOnDate" class="text-danger">
                                        A data da aplicação não pode ser uma data futura. 
                                    </small>
                            </validation-provider>
                            </b-form-group>
                       </b-col>
                       <b-col lg="6" md="12" sm="12">
                           <b-form-group 
                            label="Dose Aplicada*"
                            label-for="lote-input">
                                <validation-provider
                                #default="{ errors }"
                                name="dose"
                                rules="required"
                                >
                                    <v-select 
                                    id="dose-input"
                                    v-model="item.dose"
                                    :options="doseDisponivelSelect"
                                    label="descricao"
                                    placeholder="Selecione a dose"
                                    :disabled="!item.lote || doseSelect.length === 0 || doseDisponivelSelect.length === 0 || doseSelect.length === 1"
                                    :clearable="true"
                                    >
                                    <span slot="no-options">Nenhuma opção selecionável.</span>
                                    </v-select>
                                    <small v-if="doseSelect.length > 0 && doseDisponivelSelect.length === 0" class="text-danger">
                                      Este colaborador já recebeu esta vacina nesta campanha.
                                    </small>
                                    <small v-if="errors[0]" class="text-danger">
                                        Este campo é de preenchimento obrigatório.
                                    </small>
                                </validation-provider>
                            </b-form-group>
                       </b-col>
                       <b-col lg="6" md="12" sm="12">
                           <b-form-group 
                            label="Local de Aplicação*"
                            label-for="local-input">
                                <validation-provider
                                #default="{ errors }"
                                name="local"
                                rules="required"
                                >
                                    <v-select 
                                      id="local-input"
                                      v-model="item.local_aplicacao"
                                      :options="localAplicacaoSelect"
                                      label="descricao"
                                      placeholder="Local de Aplicação"
                                      :disabled="!item.lote"
                                      :clearable="true"
                                    >
                                    <span slot="no-options">Nenhuma opção selecionável.</span>
                                    </v-select>
                                    <small v-if="errors[0]" class="text-danger">
                                        Este campo é de preenchimento obrigatório.
                                    </small>
                                </validation-provider>
                            </b-form-group>
                       </b-col>
                       <b-col lg="6" md="12" sm="12">
                           <b-form-group 
                            label="Tipo de Aplicação*"
                            label-for="tipo-input">
                                <validation-provider
                                #default="{ errors }"
                                name="tipo"
                                rules="required"
                                >
                                    <v-select 
                                    id="tipo-input"
                                    v-model="item.tipo_aplicacao"
                                    :options="tipoAplicacaoSelect"
                                    label="descricao"
                                    placeholder="Tipo de Aplicação"
                                    :disabled="!item.lote"
                                    :clearable="true"
                                    >
                                    <span slot="no-options">Nenhuma opção selecionável.</span>
                                    </v-select>
                                    <small v-if="errors[0]" class="text-danger">
                                        Este campo é de preenchimento obrigatório.
                                    </small>
                                </validation-provider>
                            </b-form-group>
                       </b-col>
                       <b-col v-if="exibirEnderecoSelect" lg="12" md="12" sm="12">
                          <b-form-group
                              label="Endereço Empresa*"
                              label-for="endereco-input">
                            <validation-provider
                                #default="{ errors }"
                                name="endereco"
                                rules="required"
                            >
                              <v-select
                                  id="endereco-input"
                                  v-model="item.endereco"
                                  variant="custom"
                                  :options="enderecoSelect"
                                  label="id_empresa_endereco"
                                  placeholder="Endereço empresa"
                                  :clearable="true"
                              >
                                <template #option="data" >
                                  <span>
                                      <b>{{ data.descricao }}</b><br/>
                                      {{ formatEndereco(data) }}
                                  </span>
                                                </template>
                                                <template #selected-option="data">
                                  <span>
                                      <b>{{ data.descricao }}</b><br/>
                                      {{ formatEndereco(data) }}
                                  </span>
                                </template>
                                <span slot="no-options">Nenhuma opção selecionável.</span>
                              </v-select>
                              <small v-if="errors[0]" class="text-danger">
                                Este campo é de preenchimento obrigatório.
                              </small>
                            </validation-provider>
                          </b-form-group>
                       </b-col>
                      <b-col lg="6" md="12" sm="12" v-if="ativarCondicaoMaternal">
                        <b-form-group
                            label="Condição Maternal*"
                            label-for="condicao-maternal-input">
                          <validation-provider
                              #default="{ errors }"
                              name="condicao_maternal"
                              rules="required"
                          >
                            <v-select
                                id="condicao-maternal-input"
                                v-model="item.condicao_maternal"
                                :options="condicaoMaternalSelect"
                                label="label"
                                placeholder="Condição Maternal"
                                :clearable="true"
                            >
                              <span slot="no-options">Nenhuma opção selecionável.</span>
                            </v-select>
                            <small v-if="errors[0]" class="text-danger">
                              Este campo é de preenchimento obrigatório.
                            </small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      </b-row>
                </b-form>
            </validation-observer>
        </div>
        <section class="d-flex justify-content-center mb-1">
                <b-button id="save-entrada"
                    class="mr-2 mb-2-sm" 
                    variant="custom-blue"
                    @click.prevent="confirmAction"
                    :disabled="saving || errorOnDate || doseDisponivelSelect.length === 0"
                >
                    <feather-icon icon="CheckIcon" class="mr-50"/>
                    <span class="align-middle">Vacinar</span>
                    <span v-if="saving" class="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>
                </b-button>
                <b-button id="cancel-entrada" 
                    :disabled="saving"
                    variant="outline-danger"
                    @click.prevent="cancelAction"
                >
                    <feather-icon icon="XIcon" class="mr-50"/>
                    <span class="align-middle">Descartar</span>
                </b-button>
            </section>
    </b-modal>

    <ModalAlertaInformativo
        :modalShow="modalConfirm.showModal"
        :infoText="modalConfirm.infoText"
        @confirmed="proceedWithVaccination"
        @canceled="cancelAgeValidation"
    />
  </div>
</template>

<script>
import { BModal, BForm, BCol, BRow, BFormGroup, BFormInput, 
BButton, BTable, VBTooltip, BSpinner, BCard,
BFormDatepicker, BInputGroup, BInputGroupAppend, BAlert } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VueCleave from 'vue-cleave-component'
import { required } from '@validations'
import moment from 'moment';
import vSelect from 'vue-select';
import handleErrorsService from '@/views/custom-pages/Vacinacao/Services/HandleErrors';
import ModalAlertaInformativo from './ModalAlertaInformativo.vue';

export default {
  components: {
        BModal, BForm, BCol, BRow, BFormGroup, BFormInput, 
BButton, BTable, VBTooltip, BSpinner, BCard, vSelect,
BFormDatepicker, BInputGroup, BInputGroupAppend,
ValidationProvider, ValidationObserver, VueCleave,BAlert,
ModalAlertaInformativo
    },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    doses: {
        type: Array,
        default: []
    },
    loteSelect: {
        type: Array,
        default: []
    },
    vacinadorSelect: {
        type: Array,
        default: []
    },
    colaborador: {
        default: null
    },
    empresa: {
        default: null
    },
    tipoCampanha: {
        default: null
    },
    idCampanha: {
        default: null
    },
    unidade: {
        default: null
    },
    idEndereco: {
        default: null
    },
    vacinasCampanha: {
        type: Array,
        default: () => []
    },
    idDepartamento: {
        default: null
    },
    idGrupo: {
        default: null,
        required: false
    },
    enderecoSelect: {
      type: Array,
      default: () => []
    },
    exibirEnderecoSelect: {
      type: Boolean,
      default: false
    },
    sizeModal: {
      type: String,
      default: 'md'
    }
  },
  data() {
    return {
        doseSelect: [],
        tipoAplicacaoSelect: [],
        localAplicacaoSelect: [],
        required,
        item: {
            vacina: null,
            lote: null,
            vacinador: null,
            endereco: null,
            data_aplicacao: new Date(),
            condicao_maternal: [],
            doses: null,
            local_aplicacao: null,
            tipo_aplicacao: null,
            errorApi: {
                error: ''
            }
        },
      ativarCondicaoMaternal: false,
        input: {
            data_aplicacao: ''
        },
        errorOnDate: false,
        saving: false,
        condicaoMaternalSelect: [
          { value: 1, label: "Nenhuma" },
          { value: 2, label: "Gestante" },
          { value: 3, label: "Puérpera" }
        ],
        modalConfirm: {
          showModal: false,
          infoText: 'A idade ou intervalo informado não corresponde ao recomendado para esta dose. Deseja continuar?',
        },
        vacinaData: null,
        periodoIntervalo: null,
        intervaloDoses: null
    }
  },

  mounted() {
    this.setPicker();
    this.autoPreencherCamposUnicos();
  },

  computed: {
    vacinasDisponiveis() {
      if (!this.vacinasCampanha || this.vacinasCampanha.length === 0) return [];
      if (!this.loteSelect || this.loteSelect.length === 0) return [];

      const vacinasComLote = new Set(
        this.loteSelect
          .filter(lote => lote.saldo > 0)
          .map(lote => lote.id_vacina)
      );

      return this.vacinasCampanha.filter(vacina => vacinasComLote.has(vacina.id_vacina));
    },
    doseDisponivelSelect() {
      if (!this.doses || this.doses.length === 0) return this.doseSelect;

      const idsDosesAplicadas = this.doses
        .filter(d => 
          (d.situacao === 'Aplicada' || d.situacao === 'Finalizada') &&
          d.id_vacina === this.item.vacina?.id_vacina
        )
        .map(d => d.id_dose)
        .filter(Boolean);

      const idsUnicos = [...new Set(idsDosesAplicadas)];

      return this.doseSelect.filter(dose => !idsUnicos.includes(dose.id_dose));
    },
    lotesFiltrados() {
      if (!this.loteSelect || this.loteSelect.length === 0) return [];

      if (!this.item.vacina) return [];

      return this.loteSelect.filter(lote => 
        lote.id_vacina === this.item.vacina.id_vacina && lote.saldo > 0
      );
    }
  },

  watch: {
    'item.vacina': {
      handler(newVal) {
        this.item.lote = '';
        this.item.dose = '';
        this.doseSelect = [];
        this.tipoAplicacaoSelect = [];
        this.localAplicacaoSelect = [];

        if (newVal && this.lotesFiltrados.length === 1) {
          this.item.lote = this.lotesFiltrados[0];
        }
      },
      immediate: false
    },
    'item.lote': {
      handler(newVal) {
        this.item.dose = '';
        this.doseSelect = [];

        if (newVal && newVal.id_vacina) {
          this.loadVacinaPorLote();
        }
      },
      immediate: false
    },
    showModal(newVal) {
      if (newVal) {
        this.autoPreencherCamposUnicos();
      }
    },
    loteSelect() {
      if (this.loteSelect.length === 0) {
        this.item.errorApi.error = 'Nenhum lote disponível para esta campanha.';
      } else {
        this.item.errorApi.error = '';
      }
    },
    colaborador(dadosColaborador) {
      this.ativarCondicaoMaternal = false;

      if(dadosColaborador.length > 0) {
        let existeMasculino = dadosColaborador.some(item => item.genero === 'Masculino');

        if(!existeMasculino) {
          this.ativarCondicaoMaternal = true;
          this.item.condicao_maternal = [{ value: 1, label: "Nenhuma" }];
        }
      }
    }
  },

  methods: {
      async loadVacinaPorLote() {
      const lote = this.item.lote;

      if (!lote || !lote.id_vacina) return;

      try {
        const response = await this.$http.get(this.$api.vaccineParameter(lote.id_vacina));
        const vacina = response.data;

        this.doseSelect = [];
        this.tipoAplicacaoSelect = [];
        this.localAplicacaoSelect = [];

        const doses = (vacina.doses || []).map(d => ({
          id_dose: d.id_dose,
          descricao: d.dose?.descricao,
          br_dose: d.dose?.br_dose,
          idade_recomendada_de: d.idade_recomendada_de,
          idade_recomendada_ate: d.idade_recomendada_ate,
          periodo_idade_recomendada_de: d.periodo_idade_recomendada_de,
          periodo_idade_recomendada_ate: d.periodo_idade_recomendada_ate
        }));


        const periodoIntervalo = vacina.periodo_intervalo_entre_doses;
        const intervaloDoses = vacina.intervalo_entre_doses;

        const tipos = vacina.tipos_aplicacao || [];
        const locais = vacina.locais_aplicacao || [];

        const mergeUniqueById = (array, key) => {
          const map = new Map();
          array.forEach(item => {
            if (item && !map.has(item[key])) map.set(item[key], item);
          });
          return Array.from(map.values());
        };

        this.tipoAplicacaoSelect = mergeUniqueById(tipos, 'id_tipo_aplicacao');
        this.localAplicacaoSelect = mergeUniqueById(locais, 'id_local_aplicacao');

        if (vacina.tipo_aplicacao_dose === 'Dose Única') {
          this.doseSelect = [{
            id_dose: 1,
            descricao: 'Única',
            br_dose: 9
          }];
        } else {
          this.doseSelect = mergeUniqueById(doses, 'id_dose');
        }

        this.autoPreencherCamposUnicos();

        this.vacinaData = vacina;
        this.periodoIntervalo = periodoIntervalo;
        this.intervaloDoses = intervaloDoses;

      } catch (error) {
        console.error('Erro ao carregar dados da vacina:', error);
      }
    },
    calculateAge(birthDate) {
      const today = new Date();
      const birth = new Date(birthDate);
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }

      return age;
    },
    calculateAgeInMonths(birthDate) {
      const today = new Date();
      const birth = new Date(birthDate);
      const yearDiff = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();

      return yearDiff * 12 + monthDiff;
    },
    calculateAgeInDays(birthDate) {
      const today = new Date();
      const birth = new Date(birthDate);
      const timeDiff = today.getTime() - birth.getTime();
      return Math.floor(timeDiff / (1000 * 3600 * 24));
    },
    calcularIdadePorPeriodo(dataNascimento, periodoIntervalo) {
      const calculadoras = {
        'anos': () => this.calculateAge(dataNascimento),
        'meses': () => this.calculateAgeInMonths(dataNascimento),
        'dias': () => this.calculateAgeInDays(dataNascimento)
      };
      
      return calculadoras[periodoIntervalo] ? calculadoras[periodoIntervalo]() : null;
    },
    validarIdadeParaPessoa(pessoa, idadeRecomendadaDe, idadeRecomendadaAte, periodoIdadeDe, periodoIdadeAte) {
      if (!pessoa.data_nascimento) {
        return true;
      }

      if (idadeRecomendadaDe && periodoIdadeDe) {
        const idadeAtual = this.calcularIdadePorPeriodo(pessoa.data_nascimento, periodoIdadeDe);
        if (idadeAtual === null) {
          return true;
        }
        if (idadeAtual < idadeRecomendadaDe) {
          return false;
        }
      }

      if (idadeRecomendadaAte && periodoIdadeAte) {
        const idadeAtual = this.calcularIdadePorPeriodo(pessoa.data_nascimento, periodoIdadeAte);
        if (idadeAtual === null) {
          return true;
        }
        if (idadeAtual > idadeRecomendadaAte) {
          return false;
        }
      }

      return true;
    },
    validateAgeInterval() {
      if (!this.vacinaData || !this.item.dose || !this.colaborador || this.colaborador.length === 0) {
        return true;
      }

      const dose = this.item.dose;
      const idadeRecomendadaDe = dose.idade_recomendada_de;
      const idadeRecomendadaAte = dose.idade_recomendada_ate;
      const periodoIdadeDe = dose.periodo_idade_recomendada_de;
      const periodoIdadeAte = dose.periodo_idade_recomendada_ate;

      if (!idadeRecomendadaDe && !idadeRecomendadaAte) {
        return true;
      }

      const resultado = this.colaborador.every(pessoa => 
        this.validarIdadeParaPessoa(pessoa, idadeRecomendadaDe, idadeRecomendadaAte, periodoIdadeDe, periodoIdadeAte)
      );
      
      return resultado;
    },
    calcularIntervaloMinimo(periodoIntervalo, intervaloDoses) {
      const conversoes = {
        'dias': 1,
        'semanas': 7,
        'meses': 30,
        'anos': 365
      };
      
      return conversoes[periodoIntervalo] ? intervaloDoses * conversoes[periodoIntervalo] : null;
    },
    validarIntervaloParaPessoa(pessoa, dataAplicacao, intervaloMinimo) {
      if (!this.doses || this.doses.length === 0) {
        return true;
      }
      const aplicacoesPessoa = this.doses.filter(dose => 
        dose.id_pessoa_fisica === pessoa.id_pessoa_fisica &&
        dose.situacao === 'Aplicada' &&
        dose.data_aplicacao
      );

      if (aplicacoesPessoa.length === 0) {
        return true;
      }

      const ultimaAplicacao = aplicacoesPessoa.reduce((maisRecente, atual) => {
        const dataAtual = new Date(atual.data_aplicacao);
        const dataMaisRecente = new Date(maisRecente.data_aplicacao);
        return dataAtual > dataMaisRecente ? atual : maisRecente;
      });

      const dataUltimaAplicacao = new Date(ultimaAplicacao.data_aplicacao);
      const diferencaEmDias = Math.floor((dataAplicacao.getTime() - dataUltimaAplicacao.getTime()) / (1000 * 60 * 60 * 24));
      
      if (diferencaEmDias < 0) {
        return true;
      }
      
      return diferencaEmDias >= intervaloMinimo;
    },
    validateIntervaloDoses() {
      if (!this.vacinaData || !this.item.dose || !this.colaborador || this.colaborador.length === 0) {
        return true;
      }

      const dataAplicacao = moment(this.item.data_aplicacao).toDate();

      const periodoIntervalo = this.vacinaData.periodo_intervalo_entre_doses;
      const intervaloDoses = this.vacinaData.intervalo_entre_doses;

      if (!periodoIntervalo || !intervaloDoses) {
        return true;
      }

      const intervaloMinimo = this.calcularIntervaloMinimo(periodoIntervalo, intervaloDoses);
      if (!intervaloMinimo) {
        return true;
      }

      return this.colaborador.every(pessoa => 
        this.validarIntervaloParaPessoa(pessoa, dataAplicacao, intervaloMinimo)
      );
    },
    confirmAction() {
        this.$refs.itemRules.validate().then(success => {
            if (success) {
                const idadeValida = this.validateAgeInterval();
                const intervaloValido = this.validateIntervaloDoses();
                
                if (!idadeValida || !intervaloValido) {
                    this.modalConfirm.infoText = 'A idade ou intervalo informado não corresponde ao recomendado para esta dose. Deseja continuar?';
                    this.modalConfirm.showModal = true;
                    return;
                }
                
                const parameters = this.prepareDataToSave();
                this.saving = true;

                this.$http.post(this.$api.vacinacao(), parameters)
                .then(() => {
                    this.saving = false;
                    this.$emit('confirmed');
                    this.emptyForm();
                    this.$refs.itemRules.reset();
                })
                .catch(({ response: { data } }) => {
                    handleErrorsService.handleErrosVacinacao(data, this.item.errorApi);
                    this.saving = false;
                })
            }
        })
    },
    prepareDataToSave() {
        let pessoas = [];       
        const isMassive = this.colaborador.length > 1;
        this.colaborador.map((item) => {
            pessoas.push({
                id_pessoa_fisica: item.id_pessoa_fisica,
                id_categoria: item.id_categoria,
            })
        })

        const pessoasSemDuplicatas = pessoas.filter((item, index, self) => self.findIndex(t => t.id_pessoa_fisica === item.id_pessoa_fisica) === index);       

        const params = {
            id_empresa: this.empresa.id_empresa,
            id_campanha: this.idCampanha,
            id_unidade: this.unidade.id_unidade,
            id_lote: this.item.lote.id_lote,
            id_usuario_aplicador: this.item.vacinador.id_usuario,
            data_aplicacao: this.item.data_aplicacao,
            dose: 1,
            massiva: isMassive,
            pessoas: pessoasSemDuplicatas,
            id_empresa_endereco: this.exibirEnderecoSelect ? this.item.endereco.id_empresa_endereco : this.idEndereco,
            tipo: this.tipoCampanha,
            condicao_maternal: this.item.condicao_maternal.value !== undefined ? this.item.condicao_maternal.value : 1,
            id_grupo: this.idGrupo,
            id_local_aplicacao: this.item.local_aplicacao?.id_local_aplicacao,
            id_tipo_aplicacao: this.item.tipo_aplicacao?.id_tipo_aplicacao,
            id_dose: this.item.dose?.id_dose ? this.item.dose.id_dose : 1,
        };

        if (this.idDepartamento) {
          params['id_departamento'] = this.idDepartamento;
        }

        return params;
    },
    cancelAction(modalEvent) {
        modalEvent.preventDefault();
        this.$emit('canceled', modalEvent);
        this.$refs.itemRules.reset();
        this.emptyForm();
    },
    setPicker() {
        this.errorOnDate = false;

        this.input.data_aplicacao = moment(this.item.data_aplicacao).format('DD/MM/YYYY');
    },
    setInput() {
        this.errorOnDate = false;

        if(new Date(this.item.data_aplicacao) > new Date()) {
            this.errorOnDate = true;
        }

        this.item.data_aplicacao = moment(this.input.data_aplicacao, 'DD/MM/YYYY').format('YYYY-MM-DD');
    },
    emptyForm() {
        this.item.vacina = '';
        this.item.vacinador = '';
        this.item.lote = '';
        this.item.data_aplicacao = new Date();
        this.item.endereco = '';
        this.item.condicao_maternal = '';
        this.item.dose = '';
        this.item.local_aplicacao = '';
        this.item.tipo_aplicacao = '';
        this.setPicker();
        this.item.errorApi.error = ''
        this.tipoAplicacaoSelect = [];
        this.localAplicacaoSelect = [];
        this.doseSelect = [];
        this.vacinaData = null;
        this.periodoIntervalo = null;
        this.intervaloDoses = null;
        this.modalConfirm.showModal = false;
    },
    formatEndereco(endereco) {
      let descricao = '';

      if(endereco.logradouro) {descricao += `${endereco.logradouro}, ` };
      if(endereco.numero) { descricao += `${endereco.numero}, ` };
      if(endereco.bairro) { descricao += `${endereco.bairro}, ` };
      if(endereco.cidadeNome) { descricao += `${endereco.cidadeNome}, ` };
      if(endereco.estadoUF) { descricao += `${endereco.estadoUF}` };

      return descricao;
    },
    autoPreencherCamposUnicos() {
      if (this.vacinasDisponiveis.length === 1 && !this.item.vacina) {
        this.item.vacina = this.vacinasDisponiveis[0];
      }
      if (this.item.vacina && this.lotesFiltrados.length === 1 && !this.item.lote) {
        this.item.lote = this.lotesFiltrados[0];
      }
      if (this.vacinadorSelect.length === 1) {
        this.item.vacinador = this.vacinadorSelect[0];
      }
      if (this.localAplicacaoSelect.length === 1) {
        this.item.local_aplicacao = this.localAplicacaoSelect[0];
      }
      if (this.tipoAplicacaoSelect.length === 1) {
        this.item.tipo_aplicacao = this.tipoAplicacaoSelect[0];
      }
      if (this.enderecoSelect.length === 1 && this.exibirEnderecoSelect) {
        this.item.endereco = this.enderecoSelect[0];
      }
      if (this.doseDisponivelSelect.length === 1) {
        this.item.dose = this.doseDisponivelSelect[0];
      }
    },
    proceedWithVaccination() {
      this.modalConfirm.showModal = false;
      
      const parameters = this.prepareDataToSave();
      this.saving = true;

      this.$http.post(this.$api.vacinacao(), parameters)
      .then(() => {
          this.saving = false;
          this.$emit('confirmed');
          this.emptyForm();
          this.$refs.itemRules.reset();
      })
      .catch(({ response: { data } }) => {
          handleErrorsService.handleErrosVacinacao(data, this.item.errorApi);
          this.saving = false;
      });
    },
    cancelAgeValidation() {
      this.modalConfirm.showModal = false;
    },
  },
}
</script>

<style scoped>
    .bloco{
      height: 200px;
    }
    .list-enter-active,
    .list-leave-active {
      transition: all 0.5s ease;
    }
    .list-enter-from,
    .list-leave-to {
      opacity: 0;
      transform: translateX(30px);
    }

    .panel-enter-active,
    .panel-leave-active {
      transition: all 0.5s ease;
    }
    .panel-enter-from,
    .panel-leave-to {
      opacity: 0;
      height: 0;
      transform: translateX(30px);
    }
    #endereco-input.vs--open >>> .vs__search {
      line-height: 1.4rem;
      min-height: 3.7rem;
    }
    @media (max-width: 1700px) {
      #endereco-input.vs--open >>> .vs__search {
        min-height: 6rem;
      }
    }
    #endereco-input >>> .vs__dropdown-option {
      white-space: normal;
      line-height: 1.3rem;
      word-break: break-word;
    }
</style>
